import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer-section">
      <Container>
        <Row className="justify-content-center">
          {/* Contact Us */}
          <Col md={6} className="footer-card">
            <Card className="address-card">
              <Card.Body>
                <h4>Contact Us</h4>
                <p>
                  <i className="fas fa-map-marker-alt"></i> 1065 SW 8th St. #1646, Miami, FL 33130
                </p>
                <p>
                  <i className="fas fa-phone-alt"></i> +1 (786) 673-0630
                </p>
                <p>
                  <i className="fas fa-envelope"></i> tesstechtechnologiesllc@gmail.com
                </p>
              </Card.Body>
            </Card>
          </Col>

          {/* Follow Us */}
          <Col md={6} className="footer-card">
            <Card className="address-card">
              <Card.Body className="text-center">
                <h4>Follow Us</h4>
                <br/>
                <ul className="social-icons">
                  <li>
                    <a href="https://www.facebook.com/people/Tesstech-Technologies-LLC/61574952393084/" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/tesstech-technologies-llc/" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </li>
                  
                  <li>
                    <a href="https://www.google.com/search?q=tesstech+technologies" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-google"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Copyright */}
        <Row>
          <Col className="footer-copyright">
            <p>Copyright &copy; 2025 All rights reserved by Tesstech Technologies LLC.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
